// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

import './DisplayMetadata.scss';

interface DisplayMetadataProps {
    items: {
        label: string;
        icon: ReactNode;
        value: ReactNode;
        hidden?: boolean;
    }[];
    direction?: 'vertical' | 'horizontal';
    className?: string;
}

export const DisplayMetadata = ({
    items = [],
    direction = 'horizontal',
    className,
}: DisplayMetadataProps): ReactElement => (
    <div className={classList('display-metadata', className, { vertical: direction === 'vertical' })}>
        {items.map(
            ({ icon, label, value, hidden }, index) =>
                !hidden && (
                    <div key={label + index} className="display-metadata__item">
                        {icon}
                        <span className="display-metadata__title">{label}</span>
                        <span>{value}</span>
                    </div>
                ),
        )}
    </div>
);
